import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/ProgressBar.module.scss';

const ProgressBar = ({ percentage, colorsPalette, percentageRanges }) => {
  let colorPalette;
  const [lowRangePalette, normalRangePalette, hightRangePalette] = colorsPalette;
  if (percentage < percentageRanges[0]) {
    colorPalette = lowRangePalette;
  } else if (percentage >= percentageRanges[0] && percentage < percentageRanges[1]) {
    colorPalette = normalRangePalette;
  } else if (percentage >= percentageRanges[1]) {
    colorPalette = hightRangePalette;
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles[`percentageLabel-${colorPalette}`]}>{percentage}%</div>
      <div className={styles.progressBar}>
        <span className={styles[`progress-${colorPalette}`]} style={{ width: `${percentage <= 100 ? percentage : 100}%` }} />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
  colorsPalette: PropTypes.arrayOf(PropTypes.string),
  percentageRanges: PropTypes.arrayOf(PropTypes.number),
};

ProgressBar.defaultProps = {
  percentage: 0,
  colorsPalette: ['orange', 'green', 'red'],
  percentageRanges: [90, 110],
};

export default ProgressBar;
